var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustrialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 20H0.75V0H23.25V20Z",
    stroke: "#E5E7EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 1.25C2.55859 1.25 2 1.80859 2 2.5V11.875V13.75V16.875C2 17.9102 2.83984 18.75 3.875 18.75H20.125C21.1602 18.75 22 17.9102 22 16.875V11.875V5.94531C22 5.23437 21.2422 4.78516 20.6172 5.12109L14.5 8.41406V5.94531C14.5 5.23437 13.7422 4.78516 13.1172 5.12109L7 8.41406V2.5C7 1.80859 6.44141 1.25 5.75 1.25H3.25Z",
    fill: "#FDC920"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustrialIcon);
export default __webpack_public_path__ + "static/media/industrial-icon.b2935f10fe3b435581df999540654cd9.svg";
export { ForwardRef as ReactComponent };